export default __webpack_public_path__ + "static/media/login_img.1fd86192.jpg";